// 客户费率模板

import { HttpBillManageList, HttpGetExportDetail } from '@/service/billing';
import TableList from "@components/templates/tablelist";
import comExcel from '@components/templates/excelalert';
import generateBill from './generateBill'
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    components: {
        generateBill,
        comExcel
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            // Tabs: {show: true},
            // formData:{},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
        };
    },
    methods: {
        ajaxRequest: HttpBillManageList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'query':
                    var url = this.$router.resolve({
                        name: "billsManageDetail",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/billing/bill/export", this.formData,
                        { executor: 'request', download: true }
                    );
                    break;
                case 'exportdetail':
                    // console.log(params.split(','))
                    if (params.split(',').length < 2) {
                        this.getExportDetail(params)
                    } else {
                        this.$VMessage.error(this.$t('fbb.billmanage.only_one', { defaultValue: '只能选择一条数据' }))
                    }
                    break;
                // case 'generate':
                //     this.operate = {
                //         show: true,
                //         title: "生成账单",
                //         width: 460,
                //         component: "generateBill",
                //         // temptype: temptype,
                //         showFooter: false,
                //     };
                //     break;
            }
        },
        getExportDetail(params) {
            this.loading = true
            HttpGetExportDetail({ billId: params }).then(res => {
                this.$VMessage.success(res.message)
                this.loading = false
                this.operate = {
                    title: this.$t('global.common.export', { defaultValue: '导出' }),
                    show: true,
                    width: 560,
                    component: "comExcel",
                    showFooter: false
                }
            }, err => {
                this.$VMessage.error(err.message)
                this.loading = false
            })
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: '查看' }),
                show: true,
                params: id,
                operate: 'query'
            }]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getProductList', 'getBillcusWareList', 'getCusproductList']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: "export",
                    theme: "info",
                },
                {
                    name:  this.$t('fbb.alloment.export_detail', { defaultValue: '导出明细' }),
                    operate: "exportdetail",
                    theme: "success",
                    batch: true,
                },
                // {
                //     name: '生成账单',
                //     operate: 'generate',
                //     theme: 'primary'
                // }
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.inbound.client_organization', { defaultValue: '客户' }),
                    key: 'EQ_organizationId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    }
                },
                // {
                //     label: "仓库",
                //     key: 'EQ_warehouseId',
                //     show: true,
                //     tag: 'vSelect',
                //     options: this.getBillcusWareList,
                //     props: {
                //         filterable: true,
                //     },
                // },
                {
                    label: this.$t('fbb.billmanage.bill_no', { defaultValue: '账单编号' }),
                    key: 'EQ_billNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.alloment.order_status', { defaultValue: '状态' }),
                    key: 'EQ_billStatus',
                    more: true,
                    tag: 'vSelect',
                    options: [
                        { value: 0, label:  this.$t('erp.distribution.created', { defaultValue: '已创建' }) },
                        { value: 1, label:  this.$t('fbb.headlogistics.confirmmed', { defaultValue: '已确认' }) },
                    ],
                },
                {
                    label: this.$t('fbb.billmanage.bill_date', { defaultValue: '月份' }),
                    key: 'EQ_billingDate',
                    more: true,
                    tag: 'vDatepicker',
                    props: {
                        format: 'yy-mm',
                        confirm: false,
                    },
                },
                {
                    label: this.$t('bi.work.task_line_id', { defaultValue: '项目' }),
                    key: 'EQ_lineId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    }
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                }, {
                    title: this.$t('fbb.inbound.client_organization', { defaultValue: '客户' }),
                    key: 'organizationName',
                }, 
                // {
                //     title: '仓库',
                //     key: 'orgWarehouseCode',
                // }, 
                {
                    title: this.$t('bi.work.task_line_id', { defaultValue: '项目' }),
                    key: 'lineName',
                }, {
                    title: this.$t('fbb.billmanage.bill_no', { defaultValue: '账单编号' }),
                    // key: 'billNo',
                    render: (h, { row }) => {
                        return <div><a class="color-link" onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.billNo}</a></div>
                    }
                }, {
                    title: this.$t('fbb.alloment.order_status', { defaultValue: '状态' }),
                    key: 'billStatus',
                    render: (h, { row }) => {
                        return row.billStatus == 1 ? this.$t('fbb.headlogistics.confirmmed', { defaultValue: '已确认' }) : this.$t('erp.distribution.created', { defaultValue: '已创建' })
                    }
                }, {
                    title: this.$t('fbb.billmanage.bill_date', { defaultValue: '月份' }),
                    key: 'billingDate',
                }, {
                    title: this.$t('fbb.billmanage.total_cost', { defaultValue: '总费用' }),
                    key: 'totalCost',
                },
                {
                    title: this.$t('global.common.currency', { defaultValue: '币种' }),
                    key: 'currency',
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'createdAt',

                }];
        },
    },
};




